import { createPrefetchableAsyncDataContext, pageDataErrorHandler } from 'src/app/shared/contexts/asyncData';

import { getPolicyPageData } from './api';
import type { PolicyPageDataLoadError } from './types';

export const {
	Context: PolicyPageDataContext,
	Provider: PolicyPageDataContextProvider,
	useContext: usePolicyPageData,
	useAsyncData: usePolicyPageDataFromApi,
	prefetchAsyncData: prefetchPolicyPageDataFromApi,
} = createPrefetchableAsyncDataContext({
	name: 'PolicyPageDataContext',
	dataProperty: 'pageData',
	getData: getPolicyPageData,
	getUniqueId: (slug, { countryCode, locale }) => `${slug}!${countryCode}:${locale}`,
	hookDeps: (slug, { countryCode, locale }) => [slug, countryCode, locale],
	errorHandler: pageDataErrorHandler<PolicyPageDataLoadError>(),
});
